import { render, staticRenderFns } from "./AuthVerify.vue?vue&type=template&id=453f07cc&scoped=true&lang=pug&"
import script from "./AuthVerify.vue?vue&type=script&lang=js&"
export * from "./AuthVerify.vue?vue&type=script&lang=js&"
import style0 from "./AuthVerify.vue?vue&type=style&index=0&id=453f07cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f07cc",
  null
  
)

export default component.exports